module.exports = __webpack_public_path__ + "img/am-4-of-july-2021-campaign.8b2bad5c.jpg";